/**
 * Contact Feature Routes
 */

import type { RouteRecordRaw } from 'vue-router';

export const contactRoutes: RouteRecordRaw[] = [
    {
        path: '/Contact',
        name: 'ContactList',
        component: () => import('./views/ContactListPage.vue'),
        meta: {
            title: 'Contact List',
            titleKey: 'contact.Contact List',
            requiresAuth: true,
            layout: 'default',
        },
    },
    {
        path: '/Contact/add-individual',
        name: 'ContactCreateIndividual',
        component: () => import('./views/ContactCreateIndividualPage.vue'),
        meta: {
            title: 'Create Individual Contact',
            titleKey: 'contact.Create Individual Contact',
            requiresAuth: true,
            layout: 'default',
        },
    },
    {
        path: '/Contact/add-corporate',
        name: 'ContactCreateCorporate',
        component: () => import('./views/ContactCreateCorporatePage.vue'),
        meta: {
            title: 'Create Corporate Contact',
            titleKey: 'contact.Create Corporate Contact',
            requiresAuth: true,
            layout: 'default',
        },
    },
    {
        path: '/Contact/:id',
        name: 'ContactDetail',
        component: () => import('./views/ContactDetailPage.vue'),
        meta: {
            title: 'Contact Detail',
            titleKey: 'contact.Contact Detail',
            requiresAuth: true,
            layout: 'default',
        },
    },
];

